var needUpdatePics = null

// 检查 value 是不是函数
function isFunction(value) {
    return Object.prototype.toString.call(value) === '[object Function]';
}

// 检查 value 是否为有效的类数组长度
function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= Number.MAX_SAFE_INTEGER;
}

// 检查 value 是否是类数组
function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}

// 判断数据是不是Object类型的数据
function isPlainObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}

// 检查 value 是否为空
const isEmpty = (value) => {
    if (value == null) {
        return true;
    }
    if (isArrayLike(value)) {
        return !value.length;
    } else if (isPlainObject(value)) {
        for (let key in value) {
            if (hasOwnProperty.call(value, key)) {
                return false;
            }
        }
        return true;
    }
    return false;
}
let getReportStateDesc = (name, tenantCode) => {
    switch (name) {
        case 'untreated':
            return '报案受理'
        case 'uncomplete':
            return '未完成'
        case 'unhold':
            return '未接通'
        case 'tbc':
            return '待审核'
        case 'returned':
            return '补充资料'
        case 'assigned':
            return '已接收'
        case 'checking':
            return '定损中'
        case 'checked':
            return '已定损'
        case 'offline':
            return '转线下'
        case 'canceled':
            return '已注销'
        case 'evidenced':
            return '已取证'
        case 'holdedOn':
            return '资料收集'
        case 'surveied':
            return '已查勘'
        case 'finished':
            return '已结案'
        case 'claiming':
            return '理赔中'
        case 'claimReturned':
            return '理赔补充'
        default:
            return '未知'
    }
}
const getReportSubStateDesc = (name, tenantCode) => {
    switch (name) {
        case 'noSubmit':
            return '未提交'
        case 'submitted':
            return '已提交'
        case 'reject':
            return '拒赔'
        case 'withdraw':
            return '用户撤案'
        case 'remitted':
            return '结案打款'
        case 'remittFailed':
            return '打款失败'
        case 'reRemitt':
            return '重新打款'
        case 'refound':
            return '银行退票'
        default:
            return ''
    }
}
export let getReportChannel = (channel)=>{
    switch(channel){
        case 'business':
            return 'B端'
        case 'client' :
            return 'C端'
        default:
            return ''
    }
}
let getVideoPic = (videoPics)=> {
    let newVideoPics = {
        afUrl: '',
        abUrl: '',
        lfUrl: '',
        lnUrl: '',
        icfUrl: '',
        icnUrl: '',
        dcmUrl: '',
        dcsUrl: '',
        dlmUrl: '',
        dlsUrl: '',
        bdfUrl: '',
        bdbUrl: '',
        lovUrl: '',
        lovnUrl: '',
        afThumbnailUrl: '',
        abThumbnailUrl: '',
        lfThumbnailUrl: '',
        lnThumbnailUrl: '',
        icfThumbnailUrl: '',
        icnThumbnailUrl: '',
        dcmThumbnailUrl: '',
        dcsThumbnailUrl: '',
        dlmThumbnailUrl: '',
        dlsThumbnailUrl: '',
        bdfThumbnailUrl: '',
        bdbThumbnailUrl: '',
        lovThumbnailUrl: '',
        lovnThumbnailUrl: ''
    }
    _.forEach(videoPics || [], function (item) {
        switch (item.location) {
            case 'af':
            {
                newVideoPics.afUrl = item.url;
                newVideoPics.afThumbnailUrl = item.thumbnail_url;
                break;
            }
            case 'ab':
            {
                newVideoPics.abUrl = item.url;
                newVideoPics.abThumbnailUrl = item.thumbnail_url;
                break;
            }
            case 'lf':
            {
                newVideoPics.lfUrl = item.url;
                newVideoPics.lfThumbnailUrl = item.thumbnail_url;
                break;
            }
            case 'ln':
            {
                newVideoPics.lnUrl = item.url;
                newVideoPics.lnThumbnailUrl = item.thumbnail_url;
                break;
            }
            case 'icf':
            {
                newVideoPics.icfUrl = item.url;
                newVideoPics.icfThumbnailUrl = item.thumbnail_url;
                break;
            }
            case 'icn':
            {
                newVideoPics.icnUrl = item.url;
                newVideoPics.icnThumbnailUrl = item.thumbnail_url;
                break;
            }
            case 'dcm':
            {
                newVideoPics.dcmUrl = item.url;
                newVideoPics.dcmThumbnailUrl = item.thumbnail_url;
                break;
            }
            case 'dcs':
            {
                newVideoPics.dcsUrl = item.url;
                newVideoPics.dcsThumbnailUrl = item.thumbnail_url;
                break;
            }
            case 'dlm':
            {
                newVideoPics.dlmUrl = item.url;
                newVideoPics.dlmThumbnailUrl = item.thumbnail_url;
                break;
            }
            case 'dls':
            {
                newVideoPics.dlsUrl = item.url;
                newVideoPics.dlsThumbnailUrl = item.thumbnail_url;
                break;
            }
            case 'bdf':
            {
                newVideoPics.bdfUrl = item.url;
                newVideoPics.bdfThumbnailUrl = item.thumbnail_url;
                break;
            }
            case 'bdb':
            {
                newVideoPics.bdbUrl = item.url;
                newVideoPics.bdbThumbnailUrl = item.thumbnail_url;
                break;
            }
            case 'lov':
            {
                newVideoPics.lovUrl = item.url;
                newVideoPics.lovThumbnailUrl = item.thumbnail_url;
                break;
            }
            case 'lovn':
            {
                newVideoPics.lovnUrl = item.url;
                newVideoPics.lovnThumbnailUrl = item.thumbnail_url;
                break;
            }
            case 'iCardF':
            {
                newVideoPics.iCardFUrl = item.url;
                newVideoPics.iCardFThumbnailUrl = item.thumbnail_url;
                break;
            }
            case 'iCardN':
            {
                newVideoPics.iCardNUrl = item.url;
                newVideoPics.iCardNThumbnailUrl = item.thumbnail_url;
                break;
            }


        }
    })
    return newVideoPics;
}


let getImgForGuide =(location)=>{
    switch (location) {
        case 'af':
            return {location:'before45',guideLanguage:'请距车约3米与车头约45°，拍出事故现场全貌，保证车牌清晰，全车入镜'}
        case 'ab':
            return {location:'after45',guideLanguage:'请距车约3米与车尾约45°，拍出事故现场全貌，保证车牌清晰，全车入镜'}
        case 'lf':
            return {location:'lossPart1',guideLanguage:'请以车损部位为中心，拍摄整车轮廓远景照片'}
        case 'ln':
            return  {location:'lossPart2',guideLanguage:'请拍摄车损部位整体近景照片，例：车门剐蹭拍整个车门，可多角度拍摄'}
        case 'icf':
            return {location:'carNumber1',guideLanguage:'车架号在雨刮器下方，请拍摄照片，保证清晰'}
        case 'icn':
            return {location:'carNumber2',guideLanguage:'车架号在雨刮器下方，请拍摄照片，保证清晰'}
        case 'dcm':
            return {location:'driver1',guideLanguage:'请把驾驶证主页按示意图摆放拍照，保证照片清晰'}
        case 'dcs':
            return {location:'driver2',guideLanguage:'请把驾驶证副页按示意图摆放拍照，保证照片清晰'}
        case 'dlm':
            return {location:'driving1',guideLanguage:'请把行驶证主页按示意图摆放拍照，保证照片清晰'}
        case 'dls':
            return {location:'driving2',guideLanguage:'请把行驶证副页按示意图摆放拍照，保证照片清晰'}
        case 'bdf':
            return {location:'bank1',guideLanguage:'请拍摄银行卡正面照片，保证清晰'}
        case 'bdb':
            return {location:'bank2',guideLanguage:'请拍摄银行卡反面面照片，保证清晰'}
        case 'lov':
            return {location:'diff1',guideLanguage:'请拍摄交通事故认定书照片，保证清晰'}
        case 'lovn':
            return {location:'diff2',guideLanguage:'请拍摄交通事故认定书细节照片，保证清晰'}
        case 'iCardF':
            return {location:'reportCard1',guideLanguage:'请拍摄身份证正面照片，保证清晰'}
        case 'iCardN':
            return {location:'reportCard2',guideLanguage:'请拍摄身份证反面照片，保证清晰'}
        case 'reportCard1':
            return {location:'reportCard1',guideLanguage:'请拍摄保险卡正面照片，保证清晰'}
        case 'reportCard2':
            return {location:'reportCard2',guideLanguage:'请拍摄保险卡反面照片，保证清晰'}
        default :
            return {location:'part-img',guideLanguage:''}

    }
}

let loadCustomerUploadImg = (obj,reportId,lossId,location,url)=>{
    if(obj.reportId==reportId){
        if(obj.ownCarLoss._id==lossId){
            obj.ownCarLoss.videoPics.map(item=>{
                if(item.location==loaction){
                    item.url=url
                }
                return item
            })
        }else {
            obj.otherCarLoss.map(otherCar=>{
                if(otherCar._id==lossId){
                    otherCar.videoPics.map(item=>{
                        if(item.location==loaction){
                            item.url=url
                        }
                        return item
                    })
                }
                return otherCar
            })
        }

    }
    return obj
}

let updateHistoryReport = (historyReports,report)=>{
    return historyReports.map(item=>{
        if(item.flowId==report.flowId){
            return Object.assign({}, item, report)
        }else {
            return item
        }
    })
}


let updateUploadImgArr = (arr,pic,isSelected) => {
    let img = {
        url:pic.url,
        remark:''
    }
    if(isSelected){ //勾选图片
        if(arr.length==0){ //数组为空
            let car = {
                carNumber:" ",
                type:" ",
                videoPics:[img]
            }
            arr.push(car)
        }else { //数组存在数据
            arr[0].videoPics.push(img)
        }
        return arr
    }else {
        let picArr = arr[0].videoPics.filter(item=>item.url !== pic.url)
        if(picArr && picArr.length > 0){
            arr[0].videoPics = picArr
        }else {
            arr = []
        }
        return arr
    }
}

let updateCurrentOperaPicArr = (arr,pic,type)=>{
    if(type){ //数组添加数据
        arr.push(pic)
        return arr
    }else { //删除该条数据

        for(var i in arr){
            if(arr[i]._id == pic._id){
                arr.splice(i,1)
            }
        }
        return arr
    }
}


let selectAllCarImgs = (picArr) =>{
    let videoPics = [] ,arr= []
    for(let i in picArr){
        if(!picArr[i].uploaded){
            let img = {
                url:picArr[i].url,
                remark:''
            }
            videoPics.push(img)
        }
    }
    let car = {
        carNumber:" ",
        type:" ",
        videoPics:videoPics
    }
    arr.push(car)
    return arr


}




let updateReportPageList = (list,report)=>{
    if(list && list.length>0){
        let newList = list.map(item=>{
            if(item.flowId===report.flowId){
                item = report
            }
            return item
        })
        return newList
    }else {
        return list
    }
}
let selectEnhanceImg = (picAttr) => {
    let allAttr = [];
    for(let temp in picAttr){
        allAttr.push(picAttr[temp])
    }
    return allAttr;
}


let updateCurrentPreviewReport = (currentReport,report)=>{
    let newReport
    if(currentReport.flowId===report.flowId){
        newReport = report
    }else {
        newReport = currentReport
    }
    return newReport
}
//银行转换简称
let bankCardShort = (bankName)=>{
    if(bankName.indexOf( "建设") != -1 ){
        return  'CCB';
    }else if(bankName.indexOf('中国银行') != -1 ){
        return 'BC';
    }else if(bankName.indexOf('农业') !=-1  ){
        return 'ABC';
    }else if(bankName.indexOf('工商') !=-1 ){
        return 'ICBC';
    }else if(bankName.indexOf('民生') !=-1 ){
        return 'CMSB';
    }else if(bankName.indexOf('招商') !=-1 ){
        return 'CMBC';
    }else if(bankName.indexOf('兴业') !=-1  ){
        return'CIB';
    }else if(bankName.indexOf('汇丰') !=-1 ){
        return 'HSBC';
    }else if(bankName.indexOf('交通') !=-1 ){
        return 'BOCM';
    }else if(bankName.indexOf('光大') !=-1  ){
        return 'CEB';
    }else{
        return '';
    }
}

let getNeedUpdatePics = ()=> {
    return needUpdatePics;
}

let setNeedUpdatePics = (v)=> {
    needUpdatePics = v;
}

export {
    getReportStateDesc,
    getReportSubStateDesc,
    getVideoPic,
    getImgForGuide,
    loadCustomerUploadImg,
    updateHistoryReport,
    updateUploadImgArr,
    updateCurrentOperaPicArr,
    selectAllCarImgs,
    updateReportPageList,
    selectEnhanceImg,
    updateCurrentPreviewReport,
    bankCardShort,
    getNeedUpdatePics,
    setNeedUpdatePics,
    isEmpty
}
